<div class="content-block">
  <div class="dx-card responsive-paddings">

<div class="content-grid">
  <div style="display: flex; justify-content: space-between;">
    <h2 class="content-block">Card disbursements</h2>
    <div style="width: 200px; margin-top: 20px;">
      BatchId: {{this.batch?.Id}}
      Status: {{this.batch?.Status}}
    </div>
  </div>

  <!-- <dx-data-grid class="dx-card wide-card" [dataSource]="dataSource" [showBorders]="false" [focusedRowEnabled]="true"
    [focusedRowIndex]="0" [columnAutoWidth]="true" [columnHidingEnabled]="true">
    <dxo-paging [pageSize]="10"></dxo-paging>
    <dxo-pager [showPageSizeSelector]="true" [showInfo]="true"></dxo-pager>
    <dxo-filter-row [visible]="true"></dxo-filter-row>
    <dxi-column dataField="Id" caption="Reference"> </dxi-column>
    <dxi-column dataField="MerchantId" caption="Merchant"
      [lookup]="{ dataSource: merchantDataSource, valueExpr: 'Id', displayExpr: 'CompanyName' }">
    </dxi-column>
    <dxi-column dataField="CardNumber" caption="Card"> </dxi-column>
    <dxi-column dataField="ApprovalDate" caption="Date & Time"> </dxi-column>
    <dxi-column dataField="CardHolderId" caption="Card Holder Id"> </dxi-column>
    <dxi-column dataField="Amount" caption="Amount"> </dxi-column>
    <dxi-column dataField="BatchId" caption="Batch Id"> </dxi-column>
     <dxi-column dataField="Status" caption="Status"
        [lookup]="{ dataSource: statusDataSource, valueExpr: 'Id', displayExpr: 'Value' }"> 

    <dxi-column dataField="Status" caption="Status"
      [lookup]="{ dataSource: statusDataSource, valueExpr: 'Id', displayExpr: 'Value' }"
      [cellTemplate]="statusCellTemplate">
    </dxi-column>

  </dx-data-grid> -->

  <ng-template #statusCellTemplate let-cellInfo="cell">
    <div [ngStyle]="getStatusCellStyle(cellInfo.data)">
      {{ getStatusText(cellInfo.value) }}
    </div>
  </ng-template>
</div>


</div></div>